
export const policyHeader = [
  'Title',
  'Status',
  'Owner',
  'Date Created',
  'Approval Date',
  'Approved by',
  'Next Review Date',
]

export const TrackingHeader = [
  'First Name',
  'Last Name',
  "Policy Name",
  'Email',
  'Agreements Updated',
]

export const TrainingHeader = [
 
  { heading: 'Username', key: 'firstName', icon: true },
  { heading: 'Category', key: 'title', icon: true },
  { heading: 'Status', key: 'reviewDate', icon: true },
  { heading: 'Certificate Number', key: 'certificateNumber', icon: true },
  { heading: 'Next Review Date', key: '', icon: false},
  { heading: 'Verified By', key: 'verifiedBy', icon: true},
]


export const policyTableData = [
  [
    'Safeguarding',
    'Published',
    'Digital Department',
    'Feb 8, 2023',
    'Feb 12, 2023',
    'John smith',
    'Aug 17, 2023',
  ],
  [
    'Safer Recruitment Policy',
    'Published',
    'Digital Department',
    'Feb 8, 2023',
    'Feb 12, 2023',
    'John le',
    'Aug 17, 2023',
  ],
  [
    'Staff Code of Conduct Policy',
    'Lapsed',
    'Digital Department',
    'Feb 8, 2023',
    'Feb 12, 2023',
    'John le',
    'Aug 17, 2023',
  ],
  [
    'Anti-Bullying Policy',
    'Not Active',
    'Digital Department',
    'Feb 8, 2023',
    'Feb 12, 2023',
    'John le',
    'Aug 17, 2023',
  ],
]

export const trackingTableData = [
  ['demo.admin', 'demo', 'admin', 'demo.admin@scrsolutions.io', 'Feb 12, 2023'],
  ['demo.client', 'demo', 'User', 'demo.user@scrsolutions.io', 'Feb 12, 2023'],
  ['John Smith', 'John', 'Smith', 'john.smith@scr.org', 'Feb 12, 2023'],
  ['Philip Mawer', 'Philip', 'Mawer', 'philip.mawer@scr.org', 'Feb 12, 2023'],
]

export const trainingTableData = [
  [
    'demo.admin',
    'Prevent Duty',
    'Active',
    '01625-25987',
    'Feb 12, 2023',
    'Yes',
  ],
  [
    'demo.client',
    'Wellbeing',
    'Active',
    '025894-356454',
    'Feb 12, 2023',
    'Yes',
  ],
  [
    'John Smith',
    'Health & Safety',
    'Lapsing',
    '65498-36251',
    'Feb 12, 2023',
    'No',
  ],
  [
    'Philip Mawer',
    'Safeguarding',
    'Expired',
    '25852-65456',
    'Feb 12, 2023',
    'No',
  ],
]

export const IncidentsDummyData = [
  {
    Report_No: 22,
    Status: 'Closed',
    Severity_Level: 'Serious Concern',
    Name_of_Candidate: 'AIME Global',
    Name_of_Employer: 'Phillp',
    Date_Reported: 'Wed 16, 2023',
    Updated_At: 'Thu 12 2023',
    Created_By: 'demo Test',
    Updated_By: 'demosamin',
  },
  {
    Report_No: 27,
    Status: 'Open',
    Severity_Level: 'Serious Concern',
    Name_of_Candidate: 'AIME Global',
    Name_of_Employer: 'Phillip',
    Date_Reported: 'Feb 16, 2023',
    Updated_At: 'Feb 12 2023',
    Created_By: 'demo woman',
    Updated_By: 'demosamin',
  },
  {
    Report_No: 23,
    Status: 'Open',
    Severity_Level: 'Minor Concern',
    Name_of_Candidate: 'AIME Global',
    Name_of_Employer: 'Mark',
    Date_Reported: 'Feb 16, 2023',
    Updated_At: 'Feb 12 2023',
    Created_By: 'demo woman',
    Updated_By: 'demosamin',
  },


]

export const IncidentsHeadersAdmin = [
  'Report_No',
  'Status',
  'Severity_Level',
  'Incident_Concerning',
  'Name_of_Employer',
  'Date_Reported',

  "Created_By",
    'Updated_At',
  'Updated_By',
]
export const IncidentsHeaders = [
  'Report_No',
  'Status',
  'Severity_Level',
  'Incident_Concerning',
  'Name_of_Employer',
  'Date_Reported',
  'Updated_By',
  'Updated_At',
]

export const WhistleblowingDummyData = [
  {
    Report_No: 23,
    Status: 'Open',
    subject: 'Inappropriate behaviour ',
    report_type: 'Anonymous',
    Date_Reported: 'Wed 16, 2023',
    Updated_At: 'Thu 12 2023',
    Created_By: 'demo.admin',
    Updated_By: 'demo.admin',
  },
  {
    Report_No: 18,
    Status: 'Open',
    subject: 'Inappropriate behaviour',
    report_type: 'Confidential',
    Date_Reported: 'Wed 16, 2023',
    Updated_At: 'Thu 12 2023',
    Created_By: 'demo.admin',
    Updated_By: 'demo.admin',
  },
  {
    Report_No: 12,
    Status: 'Open',
    subject: 'Safeguarding Violation',
    report_type: 'Confidential',
    Date_Reported: 'Wed 16, 2023',
    Updated_At: 'Thu 12 2023',
    Created_By: 'demo.admin',
    Updated_By: 'demo.admin',
  },
]

export const WhistleblowingHeadersAdmin = [
  'ID',
  'Status',
  'Subject',
  // 'Report Type',
  'Date Reported',

  "Created_By",
  'Updated By',
  'Updated At',

]
export const WhistleblowingHeaders = [
  'Report No',
  'Status',
  'Subject',
  'Report Type',
  'Date Reported',
  'Updated By',
  'Updated At',
]

export const PartnerssHeaders = ['Id', 'Name', 'Encrypted Key', 'Created at']
export const SchoolsHeaders = ['Id', 'Name','School Id',"Group Name","Role",'Status',"Verification status","Created by","Created at"]
export const UserssHeaders = ['Id', 'Name', 'Email','Status','Role',"Created at","School"]
export const UserssGroupHeaders = ['Id', 'Name', 'Email','Status','Role',"Created at","Group"]
export const GroupHeaders = ['Id', 'Name',"Group Id", 'Created By','Created at']

export const ResourcesHeader = [
  'Category Name',
  'Candidate Access',
  'Categories',
  'Resources',
]

export const ResourcesTableData = [
  ['Resources', 'Yes', '12', '2'],
  ['Training', 'Yes', '12', '2'],
]

export const SubCategoriesHeader = [
  'Sub Category Name',
  'Candidate Access',
  'Categories',
  'Resources',
]

export const resourcesHeader = [
  'Title',
  'File',
  'Candidate Access',
  'Created At',
  'Updated At',
]

export const SubCategoriesTableData = [
  ['Safe Social Media Use', 'Yes', '4', '1'],
  ['Cyberbullying Prevention and Intervention', 'Yes', '8', '0'],
  ['Privacy Settings and Online Security', 'Yes', '8', '2'],
]

export const ManageCategoriesHeader = [
  'Title',
  'Created At',
  'Created By',
  'Updated By',
  'Updated At',
  // 'Total Records',
]

export const ManageCategoriesTableData = [
  [
    'Safeguarding',
    'Feb 12, 2023',
    'Feb 12, 2023',
    'John Smith',
    'John Smith',
    'Yes',
  ],
  [
    'Prevent Duty',
    'Feb 12, 2023',
    'Feb 12, 2023',
    'Philip Mawer',
    'Philip Mawer',
    'Yes',
  ],
  ['EDI', 'Feb 12, 2023', 'Feb 12, 2023', 'demo.client', 'demo.client', 'Yes'],
]

export const CenteralRecordTableData = [
  {
    name: {
      userName: 'Philip Mawer',
      lastName: '@user.name',
      email: 'philip.mawer@scrsolutions.io',
    },
    role: 'Candidate',
    group: 'Group Name',
    status: 'Active',
  },
  {
    name: {
      userName: 'Derek Boyles',
      lastName: '@user.name',
      email: 'derek.boyles@scrsolutions.io',
    },
    role: 'Admin',
    group: 'N/A',
    status: 'Active',
  },
  {
    name: {
      userName: 'mudassir kz',
      lastName: '@user.name',
      email: 'mudassir@scrsolutions.io',
    },
    role: 'Candidate',
    group: 'Group Name',
    status: 'Inactive',
  },
  {
    name: {
      userName: 'Olga Izmaylova',
      lastName: '@user.name',
      email: 'olga.izmaylova@scrsolutions.io',
    },
    role: 'Safe Guarding Lead',
    group: 'Inactive',
    status: 'Inactive',
  },
]

export const notesData = [
  {
    title: 'Jan 29, 2024',
    title2: 'Note ID: 3',
  },
  {
    title: 'Jan 22, 2024',
    title2: 'Note ID: 2',
  },

  {
    title: 'Jan 16, 2024',
    title2: 'Note ID: 1',
  },
]

export const whistleBlowingHeader = [
  'ID',
  'Subject',
  'Report Type',
  'Date Reported',
  'Updated At',
  'Created By',
  'Updated By',
]

export const homeCards = [
  {
    title: 'Total Users',
    value: 24,
    descriptionValue: '80%',
    description: 'completed account',
    iconName: 'IconUsersCheck',
  },
  {
    title: 'Monthly Meetings',
    value: 14,
    descriptionValue: '5%',
    description: 'vs last month',
    iconName: 'IconMessageChatSquareInActive',
  },
  {
    title: 'Open Incidents',
    value: 4,
    descriptionValue: '2',
    description: 'closed last week',
    iconName: 'IconAlertTriangle',
  },
  {
    title: 'Whistleblower Reports',
    value: 3,
    descriptionValue: '0',
    description: 'closed last week',
    iconName: 'IconAnnotationAlertInActive',
  },
]

export const WhistleblowerReportsCrads = [
  {
    reportID: 23,
    subject: 'Inappropriate behaviour',
    status: 'Open',
    schoolName: '12/01/24 13:56 PM',
  },
  {
    reportID: 18,
    subject: 'Training Violation',
    status: 'Open',
    schoolName: '12/01/24 13:56 PM',
  },
  {
    reportID: 12,
    subject: 'Safeguarding Violation',
    status: 'Open',
    schoolName: '12/01/24 13:56 PM',
  },
  {
    reportID: 4,
    subject: 'Shady business on school grounds',
    status: 'Open',
    schoolName: '12/01/24 13:56 PM',
  },
  {
    reportID: 2,
    subject: 'Concerns over teacher lateness',
    status: 'Closed',
    schoolName: '12/01/24 13:56 PM',
  },
  {
    reportID: 45,
    subject: 'Inappropriate behaviour',
    status: 'Closed',
    schoolName: '12/01/24 13:56 PM',
  },
]

export const notifcationData = [
  {
    title: 'Outstanding profile records',
    description: 'Notification Description',
  },
  {
    title: 'Profile records due to expire',
    description: 'Notification Description',
  },
  {
    title: 'Profile records expired',
    description: 'Notification Description',
  },
]
